/*
 * Todanua — Fase 5. A vitrine: coleção e busca.
 *
 * Três itens moram aqui, e nenhum deles é obrigatório para a loja funcionar:
 *
 *   D2 — o interruptor "mostrar esgotados";
 *   D6 — a compra rápida a partir do card;
 *   D7 — o botão "Ver mais".
 *
 * 🔴 Os três nascem ESCONDIDOS no HTML e é este arquivo que os revela. Sem
 * JavaScript, a cliente vê a vitrine já sem as peças esgotadas, o card inteiro
 * leva para a página da peça e a paginação numérica continua funcionando —
 * tudo pelo caminho longo, nada quebrado. É a mesma decisão das setas do
 * carrossel da Fase 4: controle que não faz nada é pior que controle nenhum.
 *
 * 🔴 Zero biblioteca. `fetch`, `DOMParser` e `<dialog>` são do navegador.
 * 🔴 Zero vigia de rolagem. O "Ver mais" é botão, não rolagem infinita: rolagem
 * infinita quebra o rodapé e o botão voltar, e o plano pede o botão.
 *
 * 🔴 AS DUAS CORRIDAS. Esta página tem duas coisas acontecendo ao mesmo tempo,
 * e as duas foram apontadas pela revisão:
 *   - a cliente abre a compra rápida da peça A, fecha e abre a da peça B: a
 *     resposta atrasada de A não pode escrever dentro da caixa de B;
 *   - a cliente toca em "Ver mais" e marca um filtro antes de a página chegar:
 *     os produtos da página antiga não podem ser colados na grade filtrada.
 * Os dois casos são resolvidos com um contador de geração, e não com um
 * `setTimeout` na esperança de que dê tempo.
 */
(function () {
  'use strict';

  const SOLD_KEY = 'td:showSoldOut';
  const HIDE_CLASS = 'td-grid--hide-out';

  // Contadores de geração. `quickToken` invalida uma busca de compra rápida
  // quando outra começa ou quando a caixa fecha; `gridToken` invalida um "Ver
  // mais" quando a grade foi trocada pelas facetas.
  let quickToken = 0;
  let gridToken = 0;
  let observer = null;

  /* ---------------------------------------------------------------- D2 --- */

  function soldGrids() {
    // Só as grades que DECLARAM a função. Sem isto, a página de busca — que
    // não tem interruptor nenhum — herdaria a classe que esconde esgotados e
    // os resultados sumiriam sem nenhum controle na tela.
    return document.querySelectorAll('[data-td-sold-grid]');
  }

  function soldPreference() {
    try {
      return window.localStorage.getItem(SOLD_KEY) === '1';
    } catch (e) {
      // Janela anônima, cookies bloqueados: a preferência simplesmente não
      // persiste. Nunca deixar isso derrubar o resto do arquivo.
      return false;
    }
  }

  function rememberSold(show) {
    try {
      window.localStorage.setItem(SOLD_KEY, show ? '1' : '0');
    } catch (e) {
      /* sem persistência, e tudo bem */
    }
  }

  function paintSold(show) {
    soldGrids().forEach(function (grid) {
      grid.classList.toggle(HIDE_CLASS, !show);
    });
    document.querySelectorAll('[data-td-sold-toggle]').forEach(function (button) {
      button.setAttribute('aria-pressed', show ? 'true' : 'false');
      const on = button.querySelector('[data-td-sold-on]');
      const off = button.querySelector('[data-td-sold-off]');
      if (on) on.hidden = show;
      if (off) off.hidden = !show;
    });
  }

  // O número é CONTADO na página, e não herdado do servidor. Motivo: o "Ver
  // mais" traz páginas novas, e a segunda pode ter esgotados que a primeira
  // não tinha. Com o número congelado no HTML, essas peças ficariam escondidas
  // sem controle nenhum na tela.
  function refreshSoldToggle() {
    const grids = soldGrids();
    if (!grids.length) return;
    let hidden = 0;
    grids.forEach(function (grid) {
      hidden += grid.querySelectorAll('.td-out').length;
    });
    document.querySelectorAll('[data-td-sold]').forEach(function (box) {
      box.hidden = hidden === 0;
      const count = box.querySelector('[data-td-sold-count]');
      if (count) count.textContent = String(hidden);
    });
  }

  /* ---------------------------------------------------------------- D6 --- */

  function quickDialog() {
    return document.getElementById('TdQuickBuy');
  }

  function openQuick(url) {
    const dialog = quickDialog();
    if (!dialog) {
      window.location.href = url;
      return;
    }
    const body = dialog.querySelector('[data-td-quick-body]');
    const token = ++quickToken;

    // Limpa o conteúdo da peça anterior ANTES de abrir. Sem isto, a caixa
    // abriria mostrando a peça errada por um instante — e num toque rápido a
    // cliente poderia até adicionar a peça anterior.
    if (body) {
      body.querySelectorAll('[data-td-quick-inner]').forEach(function (old) {
        old.remove();
      });
      const loading = body.querySelector('.td-quick__loading');
      if (loading) loading.hidden = false;
    }
    // Abre ANTES de buscar. A caixa aparece na hora com a linha de
    // "carregando" e o conteúdo cai dentro dela — em vez de a cliente tocar no
    // botão e a tela ficar parada esperando a rede.
    if (typeof dialog.showModal === 'function' && !dialog.open) dialog.showModal();

    const separator = url.indexOf('?') === -1 ? '?' : '&';
    fetch(url + separator + 'section_id=td-quick-buy')
      .then(function (response) {
        if (!response.ok) throw new Error('');
        return response.text();
      })
      .then(function (html) {
        // Chegou tarde: outra peça já foi aberta, ou a caixa já foi fechada.
        if (token !== quickToken || !body) return;
        const parsed = new DOMParser().parseFromString(html, 'text/html');
        const inner = parsed.querySelector('[data-td-quick-inner]');
        if (!inner) throw new Error('');
        const loading = body.querySelector('.td-quick__loading');
        if (loading) loading.hidden = true;
        body.appendChild(inner);
        // O foco vai para o primeiro tamanho, quando existe. Quem chegou aqui
        // pelo teclado precisa cair onde a decisão está.
        const first = body.querySelector('.td-quick__sizes input:not([disabled])');
        if (first) first.focus();
      })
      .catch(function () {
        // Chegou tarde? Não fazer nada — em especial, NÃO navegar: a cliente
        // pode estar olhando outra peça agora.
        if (token !== quickToken) return;
        // Falhou de verdade: não fingir. A cliente vai para a página da peça,
        // que é o caminho completo e sempre funciona.
        if (dialog.open) dialog.close();
        window.location.href = url;
      });
  }

  function quickSelection(scope) {
    return scope.querySelector('.td-quick__sizes input:checked');
  }

  function refreshQuickButton(scope) {
    const button = scope.querySelector('[data-td-quick-add]');
    if (!button) return;
    const label = button.querySelector('[data-td-quick-label]');
    const chosen = quickSelection(scope);
    if (!chosen) return;
    if (label && button.dataset.labelAdd) label.textContent = button.dataset.labelAdd;
    const price = scope.querySelector('[data-td-quick-price]');
    if (price && chosen.dataset.price) price.textContent = chosen.dataset.price;
  }

  /* ---------------------------------------------------------------- D7 --- */

  function paintPaging() {
    document.querySelectorAll('[data-td-more]').forEach(function (wrapper) {
      const button = wrapper.querySelector('.td-more__button');
      const usable = Boolean(button) && Boolean(wrapper.getAttribute('data-next'));
      if (button) button.hidden = !usable;
      const nav = wrapper.parentElement && wrapper.parentElement.querySelector('.pagination-wrapper');
      // A numeração só sai da tela quando existe um botão que FUNCIONA. Sem
      // esta condição, o socorro do `catch` se desfazia sozinho: eu removia o
      // botão, o observador chamava `reveal`, e a numeração era escondida de
      // novo — a cliente ficava sem os dois.
      if (nav) nav.classList.toggle('td-paging--replaced', usable);
    });
  }

  function loadMore(wrapper) {
    const next = wrapper.getAttribute('data-next');
    if (!next) return;
    const token = gridToken;
    const button = wrapper.querySelector('.td-more__button');
    const status = wrapper.querySelector('.td-more__status');
    if (button) {
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
    }

    fetch(next)
      .then(function (response) {
        if (!response.ok) throw new Error('');
        return response.text();
      })
      .then(function (html) {
        // A grade mudou embaixo de mim (a cliente marcou um filtro enquanto a
        // página vinha). Colar produtos da página antiga numa grade filtrada
        // mostraria peças que não passam no filtro — e ainda trocaria o
        // endereço pelo da paginação velha.
        if (token !== gridToken || !wrapper.isConnected) return;

        const parsed = new DOMParser().parseFromString(html, 'text/html');
        const source = parsed.querySelector('.product-grid');
        const target = document.querySelector('.product-grid');
        if (!source || !target) throw new Error('');

        const added = source.children.length;
        while (source.firstElementChild) target.appendChild(source.firstElementChild);

        // O endereço passa a ser o da última página carregada. Isso é
        // `replaceState`, e não `pushState`, de propósito: o botão VOLTAR tem
        // de levar a cliente para onde ela estava antes da vitrine, e não
        // desfazer um "ver mais" de cada vez.
        /* Rodada 2: o endereço NÃO muda mais para ?page=N. Recarregar ou compartilhar esse
           endereço mostrava só a página N, não a lista 1…N que a cliente via. O endereço fica
           o da vitrine (com filtros e ordem), que recarrega do começo — previsível. */

        const nextWrapper = parsed.querySelector('[data-td-more]');
        const nextUrl = nextWrapper && nextWrapper.getAttribute('data-next');
        if (nextUrl) {
          wrapper.setAttribute('data-next', nextUrl);
        } else {
          wrapper.removeAttribute('data-next');
          if (button) button.remove();
        }
        if (button) {
          button.disabled = false;
          button.removeAttribute('aria-busy');
        }

        if (status && added) {
          // Quem usa leitor de tela não vê os cards chegarem. `role="status"`
          // no elemento faz o navegador anunciar esta frase.
          status.textContent = status.getAttribute('data-added') || '';
        }
        reveal();
      })
      .catch(function () {
        if (token !== gridToken) return;
        // Sem inventar. O botão sai e a paginação numérica volta a aparecer —
        // é o `paintPaging` quem devolve, porque o botão deixou de existir.
        wrapper.removeAttribute('data-next');
        if (button) button.remove();
        paintPaging();
      });
  }

  /* --------------------------------------------------------------- init --- */

  function reveal() {
    // 🔴 O observador PARA enquanto eu mexo no DOM. Sem isto, cada `hidden`
    // que eu removo dispara uma mutação, que chama `reveal` de novo, que
    // remove outro `hidden`... É o laço clássico de MutationObserver, e ele
    // não aparece em máquina rápida: aparece no celular da cliente.
    if (observer) observer.disconnect();

    document.querySelectorAll('.td-quick-open[hidden]').forEach(function (button) {
      button.hidden = false;
    });

    refreshSoldToggle();
    paintSold(soldPreference());
    paintPaging();
    watchGrid();
  }

  function watchGrid() {
    const container = document.getElementById('ProductGridContainer');
    if (!container || !window.MutationObserver) return;
    // As facetas do Dawn re-renderizam a grade inteira a cada filtro marcado.
    // Sem este observador, o botão de compra rápida ficaria escondido e o
    // interruptor de esgotados voltaria ao padrão no primeiro filtro — sem
    // erro nenhum no console, que é o pior tipo de defeito.
    if (!observer) {
      observer = new MutationObserver(function () {
        gridToken += 1;
        window.requestAnimationFrame(reveal);
      });
    }
    observer.observe(container, { childList: true, subtree: true });
  }

  document.addEventListener('click', function (event) {
    const soldToggle = event.target.closest('[data-td-sold-toggle]');
    if (soldToggle) {
      event.preventDefault();
      const show = soldToggle.getAttribute('aria-pressed') !== 'true';
      rememberSold(show);
      paintSold(show);
      return;
    }

    const quick = event.target.closest('[data-td-quick]');
    if (quick) {
      event.preventDefault();
      openQuick(quick.getAttribute('data-td-quick'));
      return;
    }

    const more = event.target.closest('[data-td-more] .td-more__button');
    if (more) {
      event.preventDefault();
      loadMore(more.closest('[data-td-more]'));
      return;
    }

    const add = event.target.closest('[data-td-quick-add]');
    if (add) {
      event.preventDefault();
      const scope = add.closest('[data-td-quick-inner]');
      if (!scope) return;

      let variant = add.getAttribute('data-variant');
      if (!variant) {
        const chosen = quickSelection(scope);
        if (!chosen) {
          // E11 da Fase 2, valendo aqui igual: o botão não fica morto. Ele
          // leva a cliente até onde falta decidir.
          const first = scope.querySelector('.td-quick__sizes input:not([disabled])');
          if (first) first.focus();
          scope.querySelectorAll('.td-quick__sizes').forEach(function (group) {
            group.classList.add('td-quick__sizes--ask');
            window.setTimeout(function () {
              group.classList.remove('td-quick__sizes--ask');
            }, 1000);
          });
          return;
        }
        variant = chosen.value;
      }

      const error = scope.querySelector('.td-quick__error');
      if (error) error.hidden = true;
      add.disabled = true;
      add.setAttribute('aria-busy', 'true');

      const finish = function () {
        add.disabled = false;
        add.removeAttribute('aria-busy');
      };

      if (typeof window.tdCartAdd !== 'function') {
        // Sem a gaveta na página, o caminho honesto é o carrinho de verdade.
        window.location.href = (window.routes && window.routes.cart_url) || '/cart';
        return;
      }

      // O foco volta para o ícone do carrinho, e não para o botão da caixa: a
      // caixa vai fechar, e devolver foco a um elemento que saiu da tela deixa
      // quem navega por teclado sem lugar nenhum.
      window
        .tdCartAdd(variant, 1, document.getElementById('cart-icon-bubble'))
        .then(function () {
          const dialog = quickDialog();
          if (dialog && dialog.open) dialog.close();
          finish();
        })
        .catch(function (err) {
          if (error) {
            error.textContent = (err && err.message) || (window.cartStrings && window.cartStrings.error) || '';
            error.hidden = false;
          }
          finish();
        });
    }
  });

  document.addEventListener('change', function (event) {
    const input = event.target.closest('.td-quick__sizes input');
    if (!input) return;
    const scope = input.closest('[data-td-quick-inner]');
    if (scope) refreshQuickButton(scope);
  });

  // Fechar a caixa invalida qualquer busca em voo: uma resposta atrasada não
  // pode reabrir conteúdo numa caixa que a cliente já mandou fechar.
  document.addEventListener('close', function (event) {
    if (event.target && event.target.id === 'TdQuickBuy') quickToken += 1;
  }, true);

  // O editor de temas desconecta e reconecta a seção a cada ajuste. Sem isto,
  // a partir do segundo ajuste os botões voltariam a nascer escondidos.
  document.addEventListener('shopify:section:load', reveal);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', reveal);
  } else {
    reveal();
  }
})();
